import LegalPage from '../components/LegalPage';
import { LEGAL_INFO } from '../legalInfo';

const { companyName, website, privacyEmail, minimumAge } = LEGAL_INFO;

const SECTIONS = [
  {
    id: 'informacion',
    title: 'Información que recopilamos',
    content: (
      <>
        <p>Recopilamos únicamente la información necesaria para prestar el servicio:</p>
        <ul>
          <li>
            <strong>Datos de cuenta:</strong> nombre, correo electrónico, nombre de usuario,
            contraseña (almacenada cifrada) y foto de perfil si decides agregarla.
          </li>
          <li>
            <strong>Datos de tu bitácora:</strong> operaciones que registras manualmente o
            importas, como símbolo, tipo de instrumento (acción u opción), fecha, precio,
            cantidad, comisiones, estrategia, etiquetas y notas.
          </li>
          <li>
            <strong>Contenido de la comunidad:</strong> publicaciones, comentarios, reacciones
            y movimientos que decidas compartir públicamente o con tus seguidores.
          </li>
          <li>
            <strong>Datos de pago:</strong> si contratas un plan de pago, los datos de tu
            tarjeta los procesa directamente nuestro proveedor de pagos. {companyName} no
            almacena números completos de tarjeta.
          </li>
          <li>
            <strong>Datos técnicos:</strong> dirección IP, tipo de navegador y dispositivo,
            sistema operativo, páginas visitadas y registros de actividad necesarios para la
            seguridad y el funcionamiento de la plataforma.
          </li>
        </ul>
        <p>
          {companyName} no solicita ni almacena las credenciales de acceso a tu cuenta de
          bróker.
        </p>
      </>
    ),
  },
  {
    id: 'uso',
    title: 'Cómo usamos tu información',
    content: (
      <ul>
        <li>Crear y administrar tu cuenta.</li>
        <li>Guardar tu bitácora y generar estadísticas, gráficas y reportes de rendimiento.</li>
        <li>Mostrar el contenido que decides compartir en la comunidad.</li>
        <li>Procesar pagos y gestionar suscripciones.</li>
        <li>Enviarte avisos sobre tu cuenta, cambios del servicio y, si lo aceptas, novedades.</li>
        <li>Detectar fraudes, abusos y proteger la seguridad de la plataforma.</li>
        <li>Mejorar el producto mediante métricas de uso agregadas.</li>
        <li>Cumplir obligaciones legales.</li>
      </ul>
    ),
  },
  {
    id: 'bitacora-privada',
    title: 'Tu bitácora es privada por defecto',
    content: (
      <>
        <p>
          Todas las operaciones que registras son privadas a menos que tú decidas
          compartirlas. Al publicar un movimiento en la comunidad, puedes elegir qué datos
          mostrar (por ejemplo, ocultar montos o tamaño de posición).
        </p>
        <p>
          El contenido que hagas público podrá ser visto, comentado y compartido por otros
          usuarios. Puedes eliminar tus publicaciones en cualquier momento, aunque es posible
          que terceros hayan guardado copias antes de su eliminación.
        </p>
      </>
    ),
  },
  {
    id: 'compartir',
    title: 'Con quién compartimos tu información',
    content: (
      <>
        <p>
          <strong>No vendemos tu información personal.</strong> Solo la compartimos en los
          siguientes casos:
        </p>
        <ul>
          <li>
            <strong>Proveedores de servicios:</strong> alojamiento, bases de datos, envío de
            correos, procesamiento de pagos y analítica, bajo acuerdos de confidencialidad y
            únicamente para prestar el servicio.
          </li>
          <li>
            <strong>Otros usuarios:</strong> solo el contenido que decides hacer público en la
            comunidad y tu perfil público.
          </li>
          <li>
            <strong>Obligaciones legales:</strong> cuando lo exija una ley, orden judicial o
            autoridad competente.
          </li>
          <li>
            <strong>Operaciones corporativas:</strong> en caso de fusión, adquisición o venta
            de activos, notificándote previamente.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 'conservacion',
    title: 'Conservación de datos',
    content: (
      <p>
        Conservamos tu información mientras tu cuenta esté activa. Si eliminas tu cuenta,
        borraremos o anonimizaremos tus datos en un plazo máximo de 30 días, salvo la
        información que debamos conservar por obligaciones legales, fiscales o para resolver
        disputas.
      </p>
    ),
  },
  {
    id: 'seguridad',
    title: 'Seguridad',
    content: (
      <p>
        Aplicamos medidas técnicas y organizativas para proteger tu información, incluyendo
        cifrado en tránsito (HTTPS/TLS), cifrado de contraseñas, controles de acceso y
        monitoreo de actividad sospechosa. Ningún sistema es completamente infalible, por lo
        que te recomendamos usar una contraseña única y activar la autenticación en dos pasos
        cuando esté disponible.
      </p>
    ),
  },
  {
    id: 'derechos',
    title: 'Tus derechos',
    content: (
      <>
        <p>Dependiendo de tu país de residencia, puedes tener derecho a:</p>
        <ul>
          <li>Acceder a los datos personales que tenemos sobre ti.</li>
          <li>Corregir datos inexactos o incompletos.</li>
          <li>Solicitar la eliminación de tu cuenta y tus datos.</li>
          <li>Exportar tu bitácora en un formato portable.</li>
          <li>Oponerte o limitar ciertos tratamientos, como las comunicaciones comerciales.</li>
          <li>Retirar tu consentimiento en cualquier momento.</li>
        </ul>
        <p>
          Puedes ejercer estos derechos desde la configuración de tu cuenta o escribiendo a{' '}
          <a href={`mailto:${privacyEmail}`}>{privacyEmail}</a>. Responderemos en un plazo
          máximo de 30 días.
        </p>
      </>
    ),
  },
  {
    id: 'cookies',
    title: 'Cookies y tecnologías similares',
    content: (
      <p>
        Usamos cookies esenciales para mantener tu sesión iniciada y recordar tus
        preferencias, y cookies analíticas para entender cómo se usa {website}. Puedes
        configurar tu navegador para bloquear o eliminar cookies, aunque algunas funciones
        podrían dejar de funcionar correctamente.
      </p>
    ),
  },
  {
    id: 'menores',
    title: 'Menores de edad',
    content: (
      <p>
        {companyName} está dirigido a personas mayores de {minimumAge} años. No recopilamos
        conscientemente información de menores. Si detectamos una cuenta de un menor, la
        eliminaremos.
      </p>
    ),
  },
  {
    id: 'transferencias',
    title: 'Transferencias internacionales',
    content: (
      <p>
        Nuestros servidores y proveedores pueden estar ubicados fuera de tu país, incluidos
        los Estados Unidos. Al usar el servicio, tu información puede transferirse y
        procesarse en esos lugares, siempre con garantías adecuadas de protección.
      </p>
    ),
  },
  {
    id: 'cambios',
    title: 'Cambios a esta política',
    content: (
      <p>
        Podemos actualizar esta política ocasionalmente. Si los cambios son relevantes, te
        avisaremos por correo electrónico o mediante un aviso en la plataforma antes de que
        entren en vigor. La fecha de la última actualización aparece al inicio de este
        documento.
      </p>
    ),
  },
  {
    id: 'contacto',
    title: 'Contacto',
    content: (
      <p>
        Si tienes preguntas sobre esta política o sobre el tratamiento de tus datos, escríbenos
        a <a href={`mailto:${privacyEmail}`}>{privacyEmail}</a>.
      </p>
    ),
  },
];

function PrivacyPage() {
  return (
    <LegalPage
      title="Política de Privacidad"
      intro={`En ${companyName} (${website}) respetamos tu privacidad. Esta política explica qué información recopilamos, cómo la usamos y qué control tienes sobre ella cuando usas nuestra bitácora de trading y nuestra comunidad.`}
      sections={SECTIONS}
      related={{ href: '/terminos/', label: 'Términos y Condiciones del Servicio' }}
    />
  );
}

export default PrivacyPage;
